import { call, put } from 'redux-saga/effects';
import { Types } from './actions';
import ExternalSettingsRepository from '@/domain/repositories/ExternalSettingsRepository';
import ExternalSettingsDataRepository from '@/data/repositories/ExternalSettingsDataRepository';

export default function* saga(): any {
  try {
    yield put({ type: Types.GET_VERSION_REQUEST });
    const externalSettingsRepository: ExternalSettingsRepository =
      new ExternalSettingsDataRepository();
    const versionResponse = yield call(externalSettingsRepository.getVersion);

    if (!versionResponse) {
      throw new Error('No se pudo leer la versión de la aplicación.');
    }

    yield put({
      type: Types.GET_VERSION_SUCCESS,
      data: versionResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_VERSION_FAILURE,
      error: 'Ocurrió un error al momento de leer la versión de la aplicación.'
    });
  }
}
